import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import HomePage from './components/HomePage.vue'
import LandingPageCritique from './components/LandingPageCritique.vue'
import VueMeta from 'vue-meta'

import { KinesisContainer, KinesisElement } from 'vue-kinesis'

Vue.component('kinesis-container', KinesisContainer)
Vue.component('kinesis-element', KinesisElement)

Vue.use(VueRouter)
Vue.use(VueMeta)

Vue.config.productionTip = false

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '/', component: HomePage},
	{ path: '/landing-page-critique', component: LandingPageCritique}
  ]
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
